import React from 'react';
import { useMaestroContext } from '../../context/MaestroContext';
import { COR_CLASSIFICACAO, LABEL_CLASSIFICACAO } from '../../utils/labels';
import Card from '../Card';
import EstadoVazio from '../EstadoVazio';

const VisaoRanking: React.FC = () => {
  // O modelo real do backend (MaestroRankingController) pontua por responsável, não por área —
  // por isso essa visão usa getUsuario(p.id)/getUsuario(d.responsavelId), nunca getArea. "Tendência"
  // saiu da tabela: o backend hoje só devolve um snapshot do ciclo atual, sem histórico pra comparar
  // — mostrar uma seta parada sempre igual seria dado fantasiado, não uma tendência real.
  const { pontuacoes, destaques, getUsuario } = useMaestroContext();

  if (pontuacoes.length === 0) {
    return <EstadoVazio icone='bi bi-trophy' titulo='Nenhuma pontuação disponível para este escopo' />;
  }

  const ordenadas = [...pontuacoes].sort((a, b) => a.posicaoRanking - b.posicaoRanking);

  return (
    <div className='mc-ranking'>
      <Card title='Destaques do ciclo' subtitle='Reconhecimento não é punitivo — o objetivo é celebrar boas práticas.'>
        <div className='mc-destaques'>
          {destaques.map(d => {
            const responsavel = getUsuario(d.responsavelId);
            return (
              <div className='mc-destaques__item' key={d.titulo}>
                <i className='bi bi-award' />
                <div>
                  <strong>{d.titulo}</strong>
                  <span>{responsavel?.nome ?? ''}</span>
                  <p>{d.descricao}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Card>

      <Card title='Ranking de desempenho' subtitle='Pontuação real (modelo PON_V1) por entregas no prazo, qualidade, colaboração e cumprimento do PDCA.'>
        <table className='mc-ranking-table'>
          <thead>
            <tr>
              <th>#</th><th>Responsável</th><th>Pontuação</th><th>Classificação</th><th>Antecipadas</th><th>No prazo</th>
            </tr>
          </thead>
          <tbody>
            {ordenadas.map(p => {
              const responsavel = getUsuario(p.id);
              return (
                <tr key={p.id}>
                  <td className='mc-num'>{p.posicaoRanking}º</td>
                  <td>{responsavel?.nome ?? `Usuário #${p.id}`}</td>
                  <td className='mc-num'><strong>{p.pontuacaoTotal}</strong></td>
                  <td><span className={`mc-badge mc-badge--${COR_CLASSIFICACAO[p.classificacao]}`}>{LABEL_CLASSIFICACAO[p.classificacao]}</span></td>
                  <td className='mc-num'>{p.entregasAntecipadas}</td>
                  <td className='mc-num'>{p.entregasNoPrazo}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card>
    </div>
  );
};

export default VisaoRanking;
